module.exports = __webpack_public_path__ + "img/background010.85255a82.jpg";